module.exports = __webpack_public_path__ + "static/img/img-educator-why-3@3x.3a3a49e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/educator/img-educator-why-3@3x.png
// module id = ZH58
// module chunks = 18